import { Subscription } from 'rxjs';
Subscription.prototype[Symbol.dispose] = function dispose() {
    this.unsubscribe();
};
//# sourceMappingURL=rxjs-disposable.js.map